import { lazy } from 'react';
import { SIGNIN_CALLBACK_PATH, SIGNOUT_CALLBACK_PATH } from '@whitelabel/xcover-shared/helpers/constants';
import { retry } from '../helpers/utils';
import { localePrefix } from './routeHelpers';

export const ConnectedHome = lazy(() =>
  retry(() => import('../containers/pages/Home' /* webpackChunkName: "Home" */)),
);
export const PDS = lazy(() => retry(() => import('../containers/pages/PDS' /* webpackChunkName: "PDS" */)));
export const StaticPage = lazy(() =>
  retry(() => import('../containers/pages/StaticPage' /* webpackChunkName: "Static" */)),
);
export const Help = lazy(() => retry(() => import('../containers/pages/Help' /* webpackChunkName: "Help" */)));
export const ConnectedCOI = lazy(() => retry(() => import('../containers/pages/COI' /* webpackChunkName: "COI" */)));
export const ConnectedNotify = lazy(() =>
  retry(() => import('../containers/pages/Notify' /* webpackChunkName: "Notify" */)),
);
export const Login = lazy(() => retry(() => import('../containers/pages/Login' /* webpackChunkName: "Login" */)));
export const LoginWithAmazon = lazy(() =>
  retry(() => import('../containers/pages/LoginWithAmazon' /* webpackChunkName: "LoginWithAmazon" */)),
);
export const LoginWithAmazonOTP = lazy(() =>
  retry(
    () =>
      import('../containers/pages/LoginWithAmazon/LoginWithAmazonOTP' /* webpackChunkName: "LoginWithAmazonOTP" */),
  ),
);

export const LoginWithAmazonCallback = lazy(() =>
  retry(
    () =>
      import(
        '../containers/pages/LoginWithAmazon/LoginWithAmazonCallback' /* webpackChunkName: "LoginWithAmazonCallback" */
      ),
  ),
);

export const SignoutCallback = lazy(() =>
  retry(() => import('../containers/pages/SignoutCallback' /* webpackChunkName: "SignoutCallback" */)),
);

export const SessionExpired = lazy(() =>
  retry(() => import('../containers/pages/LoginWithAmazon/SessionExpired' /* webpackChunkName: "SessionExpired" */)),
);

export const ConfirmSignUp = lazy(() =>
  retry(() => import('../containers/pages/ConfirmSignUp' /* webpackChunkName: "ConfirmSignUp" */)),
);
export const ForgotPassword = lazy(() =>
  retry(() => import('../containers/pages/ForgotPassword' /* webpackChunkName: "ForgotPassword" */)),
);
export const ForgotPasswordSubmit = lazy(() =>
  retry(() => import('../containers/pages/ForgotPasswordSubmit' /* webpackChunkName: "ForgotPasswordSubmit" */)),
);
export const Account = lazy(() =>
  retry(() => import('../containers/pages/Account' /* webpackChunkName: "Account" */)),
);
export const ConnectedProfile = lazy(() =>
  retry(() => import('../containers/pages/Profile' /* webpackChunkName: "Profile" */)),
);
export const ConnectedPayout = lazy(() =>
  retry(() => import('../containers/pages/Payout' /* webpackChunkName: "Payout" */)),
);
export const Logout = lazy(() => retry(() => import('../containers/pages/Logout' /* webpackChunkName: "Logout" */)));
export const FNOLRedirect = lazy(() =>
  retry(() => import('../containers/pages/FNOLRedirect' /* webpackChunkName: "FNOLRedirect" */)),
);
export const ClaimsPortalRedirect = lazy(() =>
  retry(() => import('../containers/pages/ClaimsPortalRedirect' /* webpackChunkName: "ClaimsPortalRedirect" */)),
);
export const PayoutSubmitted = lazy(() =>
  retry(() => import('../containers/pages/PayoutSubmitted' /* webpackChunkName: "PayoutSubmitted" */)),
);
export const Quote = lazy(() => retry(() => import('../containers/pages/Quote' /* webpackChunkName: "Quote" */)));
export const QuoteConfirmed = lazy(() =>
  retry(() => import('../containers/pages/Quote/QuoteConfirmed' /* webpackChunkName: "QuoteConfirmed" */)),
);
export const HelpLanding = lazy(() =>
  retry(() => import('../containers/pages/HelpLanding' /* webpackChunkName: "HelpLanding" */)),
);
export const HelpArticleLists = lazy(() =>
  retry(() => import('../containers/pages/HelpArticleLists' /* webpackChunkName: "HelpArticleLists" */)),
);
export const ConnectedModifyBooking = lazy(() =>
  retry(() => import('../containers/pages/ModifyBooking' /* webpackChunkName: "ModifyBooking" */)),
);
export const PaypalInterstitial = lazy(() =>
  retry(() => import('../containers/pages/PaypalInterstitial' /* webpackChunkName: "PaypalInterstitial" */)),
);
export const Impersonate = lazy(() =>
  retry(() => import('../containers/pages/Impersonate' /* webpackChunkName: "Impersonate" */)),
);
export const QuoteUnqualified = lazy(() =>
  retry(() => import('../containers/pages/Quote/QuoteUnqualified' /* webpackChunkName: "QuoteUnqualified" */)),
);
export const Upsell = lazy(() => retry(() => import('../containers/pages/Upsell' /* webpackChunkName: "Upsell" */)));
export const KWRedirect = lazy(() =>
  retry(() => import('../containers/pages/KWRedirect' /* webpackChunkName: "KWRedirect" */)),
);
export const QuoteRedirect = lazy(() =>
  retry(() => import('../containers/pages/Quote/QuoteRedirect' /* webpackChunkName: "QuoteRedirect" */)),
);
export const Offers = lazy(() => retry(() => import('../containers/pages/Offers' /* webpackChunkName: "Offers" */)));
export const ResearchConsent = lazy(() =>
  retry(() => import('../containers/pages/ResearchConsent' /* webpackChunkName: "ResearchConsent" */)),
);

export const EbayPaymentDetails = lazy(() =>
  retry(() => import('../containers/pages/EbayPaymentDetails' /* webpackChunkName: "EbayPaymentDetails" */)),
);
export const LoginOtp = lazy(() =>
  retry(() => import('../containers/pages/LoginOtp' /* webpackChunkName: "LoginOtp" */)),
);

export const MFAPreference = lazy(() =>
  retry(() => import('../containers/pages/MFAPreference' /* webpackChunkName: "MFAPreference" */)),
);
export const OTP = lazy(() => retry(() => import('../containers/pages/OTP' /* webpackChunkName: "OTP" */)));

export const routes = [
  // sign in/out transit page [start]
  {
    key: 'signInCallback',
    path: SIGNIN_CALLBACK_PATH,
    exact: true,
    component: LoginWithAmazonCallback,
  },
  {
    key: 'signoutCallback',
    path: SIGNOUT_CALLBACK_PATH,
    exact: true,
    component: SignoutCallback,
  },
  // sign in/out transit page [end]
  {
    key: 'home',
    path: `${localePrefix}/`,
    exact: true,
    component: ConnectedHome,
  },
  {
    key: 'pds',
    path: `${localePrefix}/pds/:id`,
    exact: true,
    component: PDS,
  },
  {
    key: 'coi',
    path: `${localePrefix}/coi/:id`,
    exact: true,
    component: ConnectedCOI,
  },
  {
    key: 'notify',
    path: `${localePrefix}/notify/:id`,
    exact: true,
    component: ConnectedNotify,
  },
  {
    key: 'help',
    path: `${localePrefix}/help/:slug`,
    exact: true,
    component: Help,
  },
  {
    key: 'helpLanding',
    path: [`${localePrefix}/help`, `${localePrefix}/help#:hashId`],
    exact: true,
    component: HelpLanding,
  },
  {
    key: 'helpArticleLists',
    path: `${localePrefix}/help/:type(partners|categories)/:slug`,
    exact: true,
    component: HelpArticleLists,
  },
  {
    key: 'quoteLanding',
    path: `${localePrefix}/get-quote/:insuranceLine`,
    component: QuoteRedirect,
  },
  {
    key: 'quoteUnqualified',
    path: `${localePrefix}/quote/unable-to-proceed`,
    component: QuoteUnqualified,
  },
  {
    key: 'quote',
    path: `${localePrefix}/quote/:quotePackageID`,
    exact: true,
    component: Quote,
  },
  {
    key: 'quoteConfirmed',
    path: `${localePrefix}/quote/:bookingID/confirmed`,
    exact: true,
    component: QuoteConfirmed,
  },
  {
    key: 'fnol',
    path: `${localePrefix}/account/claims/fnol`,
    exact: true,
    component: FNOLRedirect,
  },
  {
    key: 'claims',
    path: `${localePrefix}/claims`,
    component: ClaimsPortalRedirect,
  },
  {
    key: 'impersonate',
    path: `${localePrefix}/impersonate`,
    exact: true,
    component: Impersonate,
  },
  {
    key: 'offers',
    path: `${localePrefix}/offers`,
    exact: true,
    component: Offers,
  },
  {
    key: 'researchConsent',
    path: `${localePrefix}/research-consent`,
    exact: true,
    component: ResearchConsent,
  },
  {
    key: 'logout',
    path: `${localePrefix}/logout`,
    exact: true,
    component: Logout,
  },
  {
    key: 'loginWithAmazon',
    path: `${localePrefix}/login-with-amazon`,
    exact: true,
    component: LoginWithAmazon,
  },
  {
    key: 'SessionExpired',
    path: `${localePrefix}/session-expired`,
    exact: true,
    component: SessionExpired,
  },
  {
    key: 'loginWithAmazonOTP',
    path: `${localePrefix}/login-with-amazon-otp`,
    exact: true,
    component: LoginWithAmazonOTP,
  },
  // To do: Discuss with XCover where we want to redirect users when they visit https://www.xcover.com/en-us/home/keller-williams
  {
    key: 'old-kwRoleSelectionTwo',
    path: `${localePrefix}/kellercoveredhomewarranty`,
    component: KWRedirect,
  },
  {
    key: 'kwRoleSelection',
    path: `${localePrefix}/home/keller-williams/agents`,
    component: KWRedirect,
  },
  {
    key: 'old-kwLanding',
    path: `${localePrefix}/home/keller-williams`,
    component: KWRedirect,
  },
  {
    key: 'page',
    path: `${localePrefix}/:slug*`,
    exact: true,
    component: StaticPage,
  },
];

export const unauthRoutes = [
  {
    key: 'login',
    path: `${localePrefix}/login`,
    exact: true,
    component: Login,
  },
  {
    key: 'confirmSignUp',
    path: `${localePrefix}/signup/confirm`,
    exact: true,
    component: ConfirmSignUp,
  },
  {
    key: 'forgotPassword',
    path: `${localePrefix}/forgot-password`,
    exact: true,
    component: ForgotPassword,
  },
  {
    key: 'forgotPasswordSubmit',
    path: `${localePrefix}/forgot-password/confirm`,
    exact: true,
    component: ForgotPasswordSubmit,
  },
  {
    key: 'loginOtp',
    path: `${localePrefix}/login-otp`,
    exact: true,
    component: LoginOtp,
  },
];

export const componentsMap = {
  account: Account,
  profile: ConnectedProfile,
  payoutSubmitted: PayoutSubmitted,
  payout: ConnectedPayout,
  paypalInterstitial: PaypalInterstitial,
  modifyBooking: ConnectedModifyBooking,
  authenticatedStaticPages: StaticPage,
  offers: Offers,
  researchConsent: ResearchConsent,
  ebayPaymentDetails: EbayPaymentDetails,
  mfaPreference: MFAPreference,
  otp: OTP,
};
